<template>
  <div class="app-layout">
    <TheNavigation />
    <main class="main-content">
      <slot></slot>
    </main>
    <AppFooter />
    <CustomCursor v-if="!isMobile" />
  </div>
</template>

<script>
import TheNavigation from '@/components/layout/TheNavigation.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import CustomCursor from '@/components/common/CustomCursor.vue';

export default {
  name: 'AppLayout',
  components: {
    TheNavigation,
    AppFooter,
    CustomCursor
  },
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkIfMobile);
  },
  methods: {
    checkIfMobile() {
      this.isMobile = ('ontouchstart' in window) || 
                     (navigator.maxTouchPoints > 0) || 
                     (navigator.msMaxTouchPoints > 0);
    }
  }
}
</script>

<style lang="scss" scoped>
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}
</style> 